import {Pipe, PipeTransform} from "@angular/core";
import moment from 'moment';

@Pipe({
  name: 'humaniseSeconds'
})
export class HumaniseSecondsPipe implements PipeTransform {

  transform(value: number|null|undefined): string {
    if(value === null || value === undefined) {
      return '0';
    }

    return moment.duration(value, 'seconds').format('m[m] s[s]', { trim: false });
  }
}
